import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import CloseIcon from 'assets/icons/close-button.svg?react';
import styles from './CustomModal.module.scss';
import { ReactNode } from 'react';
import clsx from 'clsx';

export type CustomModalProps = {
  onClose: () => void;
  isOpen: boolean;
  title: string | ReactNode;
  children: ReactNode;
  containerClassName?: string;
  contentClassName?: string;
  doNotCloseOnOutsideClick?: boolean;
  titleAdditionalContent?: ReactNode;
};

export const Modal = (props: CustomModalProps) => {
  return (
    <Dialog
      className={props.containerClassName}
      open={props.isOpen}
      onClose={!props.doNotCloseOnOutsideClick ? props.onClose : undefined}
    >
      <DialogTitle className={styles.header}>
        <div className={clsx(styles.rowContainer, styles.columnGap12)}>
          <div>{props.title}</div>
          {props.titleAdditionalContent}
        </div>

        <CloseIcon
          className={styles.closeButton}
          onClick={props.onClose}
          data-test-id={'dialog-close-button'}
        />
      </DialogTitle>
      <DialogContent className={clsx(styles.content, props.contentClassName)}>
        {props.children}
      </DialogContent>
    </Dialog>
  );
};
